/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.productListToMap = productListToMap;
exports.sortByDescription = sortByDescription;
function productListToMap(productList) {
    var products = {};
    for (var i = 0; i < productList.length; i++) {
        products[productList[i].id] = productList[i];
    }
    return products;
}

function sortByDescription(a, b) {
    var nameA = a.description;
    var nameB = b.description;

    return nameA.localeCompare(nameB);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/mattermost-redux/utils/product_utils.js
// module id = 1025
// module chunks = 76